import {
  GET_ALL_LOGGED_IN_USERS_FAILURE,
  GET_ALL_LOGGED_IN_USERS_REQUEST,
  GET_ALL_LOGGED_IN_USERS_SUCCESS,
} from "./ActionType";

const initialState = {
  loggedInUsers: {},
  loading: false,
  error: null,
};

export const loggedInUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_LOGGED_IN_USERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_LOGGED_IN_USERS_SUCCESS:
      return {
        ...state,
        loggedInUsers: action.payload,
        loading: false,
        error: null,
      };
    case GET_ALL_LOGGED_IN_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
